import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Tutorial({ videoList, theme }: any) {
    const { useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const [videoModal, setVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const handlePlayVideo = (e: any) => {
        const target = e.target?.closest('.mask');
        if (!target?.classList.contains('play')) return;
        const { url, isYoutube } = target.dataset;
        if (isYoutube === 'true') {
            setVideoUrl(url);
            setVideoModal(true);
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.click();
        }
    };

    return (
        <section className={`product-support-tutorial ${css['product-support-tutorial']} ${theme}`}>
            <ul className="tutorial-videos">
                {videoList?.map((video: any, _k: number) => (
                    <li className="tutorial-video" key={video.downloadInfoId + video.fileUrl}>
                        <div
                            onClick={handlePlayVideo}
                            className="video-img play mask"
                            data-url={generatorPlayUrl(video.fileUrl).url}
                            data-is-youtube={generatorPlayUrl(video.fileUrl).isYouTubeVideo}
                        >
                            <EFPicture src={video?.poster || generatorPlayUrl(video.fileUrl)?.imageUrl || '/img/search/error.png'} alt={video.title} />
                            <svg className="play-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM28.0661 20.8524C28.7021 20.4621 28.7021 19.538 28.0661 19.1477L18.1781 13.0801C17.5118 12.6712 16.6551 13.1507 16.6551 13.9324V26.0677C16.6551 26.8495 17.5118 27.3289 18.1781 26.92L28.0661 20.8524Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <p data-url={video.fileUrl} className="video-title">
                            {video.title}
                        </p>
                    </li>
                ))}
            </ul>
            <EFVideoModal visible={videoModal} source={videoUrl} onClose={() => setVideoModal(false)} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
        </section>
    );
}
